// ============================================================
// ReportCustomer02 — รายงานลูกค้าที่ยังไม่โอนกรรมสิทธิ์
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { loading, toFixed, format_date, getStorage, replaceText, calcCommonExpenses } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

// รายงานลูกค้าที่ยังไม่โอน
async function report_customer_2(data, common_expenses, common_expenses_type) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  // ค่าส่วนกลางของห้องหนึ่ง — โครงการที่ตั้งค่าเป็น "คิดตามขนาดห้อง" ต้องคูณ ตร.ม. ของห้องนั้น
  // NOTE เดิมใช้อัตราดิบทุกห้องแล้วคูณจำนวนห้อง ทำให้โครงการที่คิดตาม ตร.ม. ยอดผิดทั้งคอลัมน์และยอดรวม
  const roomExpense = (item) => calcCommonExpenses(common_expenses_type, common_expenses || 0, item.room_size);
  const totalExpText = toFixed(data.reduce((sum, item) => sum + roomExpense(item), 0));
  const projectName = getStorage("project_name") || "";
  const currentDate = format_date(new Date(), "dd/mm/yyyy");

  let array = data.map((item, index) => [
    { text: index + 1, alignment: "center" },
    { text: item.building || "-", alignment: "center" },
    { text: item.address_number || "-", alignment: "center" },
    { text: item.full_name || "-", alignment: "left" },
    { text: item.room_size ? `${item.room_size} ตร.ม.` : "-", alignment: "right" },
    { text: toFixed(roomExpense(item)), alignment: "right" },
    { text: "-", alignment: "left" },
  ]);

  const docDefinition = {
    content: [
      { text: `รายชื่อลูกค้าที่ยังไม่โอนกรรมสิทธิ์ห้องชุด บันทึกโอนถึง วันที่ ${currentDate}`, alignment: "center", fontSize: 18, bold: true },
      { text: projectName, alignment: "center", fontSize: 18, bold: true },
      { text: " " },
      { text: `รวมเงินค่าส่วนกลางห้องชุด กรรมสิทธิ์ ${projectName} เป็นเงินทั้งสิ้น ${totalExpText} บาท`, alignment: "left" },
      {
        table: {
          headerRows: 1,
          widths: ["6%", "7%", "9%", "32%", "15%", "16%", "15%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "อาคาร", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ - สกุล", alignment: "center" },
              { text: "ขนาดห้องชุด", alignment: "center" },
              { text: "ค่าส่วนกลาง", alignment: "center" },
              { text: "หมายเหตุ", alignment: "center" },
            ],
            ...array,
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  openPdf(textDocDefinition, `รายชื่อลูกค้าที่ยังไม่โอนกรรมสิทธิ์ห้องชุด บันทึกโอนถึง วันที่ ${new Date().toISOString()}.pdf`);
}

export { report_customer_2 };